import { NotificationSubscriptionSetupItemSchema } from "./notification-subscription-setup-item";
import { NotificationSubscriptionAssignItemSchema } from "./notification-subscription-assign-item";
import { NotificationSubscriptionCountSchema } from "./notification-subscription-count";
import { ShippingItemSchema } from "@/schemas/shipping/shipping-item";
import { HardwareItemSchema } from "@/schemas/hardware/hardware-item";
import { NotificationHelpItemSchema } from "./notification-help-item";
import { z } from "zod";

export const NotificationDataSchema = z.object({
  Help: NotificationHelpItemSchema.array().optional(),
  SubscriptionCount: NotificationSubscriptionCountSchema.optional(),
  Subscription: NotificationSubscriptionAssignItemSchema.array().optional(),
  SetupSubscriptions:
    NotificationSubscriptionSetupItemSchema.array().optional(),
  Hardware: HardwareItemSchema.array().optional(),
  Shipping: ShippingItemSchema.array().optional(),
});

export type NotificationDataType = z.infer<typeof NotificationDataSchema>;
